import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useBrandsStore } from "@/stores/brands";

interface AddBrandFormProps {
  onSuccess?: () => void;
}

export function AddBrandForm({ onSuccess }: AddBrandFormProps) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const add = useBrandsStore((s) => s.add);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!name.trim()) {
      setError("Brand name is required");
      return;
    }

    try {
      await add(name.trim(), description.trim() || undefined);
      setName("");
      setDescription("");
      onSuccess?.();
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>New Brand</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit}>
          <div className="grid sm:grid-cols-[1fr_1fr_auto] gap-4 items-end">
            <div>
              <Label htmlFor="brand-name">Name</Label>
              <Input
                id="brand-name"
                placeholder="e.g. Apple, Nike, Tesla"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
              />
            </div>
            <div>
              <Label htmlFor="brand-desc">Description</Label>
              <Input
                id="brand-desc"
                placeholder="Optional context for AI evaluation"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <Button type="submit">Add</Button>
          </div>
          {error && (
            <p className="text-[13px] text-red-600 mt-3">{error}</p>
          )}
        </form>
      </CardContent>
    </Card>
  );
}
